import useCrmJobsTransitionQuery from "../queries/useCrmJobsTransitionQuery";
import type { CrmJobsTransitionDto } from "../types/crmJobsTransition";
import { hasAnyPendingCrmJobsTransition } from "../utils/crmJobsTransition";

import { useIsIndustryTaxonomyOptedIn } from "./useIsIndustryTaxonomyOptedIn";

type CrmIndustryTransitionState = {
    readonly hasPendingTransition: boolean;
    readonly data: CrmJobsTransitionDto | undefined;
};

/** Whether any connected CRM still has enrichment jobs or field mappings on the legacy industry taxonomy. */
export const useCrmIndustryTransitionState = (): CrmIndustryTransitionState => {
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();
    const { data } = useCrmJobsTransitionQuery();

    return {
        data,
        hasPendingTransition: isIndustryTaxonomyOptedIn && hasAnyPendingCrmJobsTransition(data),
    };
};

export const useHasAnyPendingCrmIndustryTransition = (): boolean => {
    return useCrmIndustryTransitionState().hasPendingTransition;
};
